import { motion } from 'framer-motion';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center bg-offwhite pt-20 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mt-12"
        >
          <h1 className="text-6xl lg:text-7xl font-light leading-tight mb-6">
            Master the Art of
            <br />
            <span className="font-serif italic text-red-600">AI Communication</span>
            <br />
            for Your Business
          </h1>
          
          <p className="text-lg text-gray-600 font-light max-w-2xl mx-auto mb-12">
            We help transform how your team collaborates with artificial intelligence through strategic prompting techniques
          </p>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToContact}
            className="bg-primary text-white px-12 py-4 rounded-full text-lg font-medium hover:shadow-xl transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
          >
            Schedule a Consultation
            <i className="ri-arrow-right-line"></i>
          </motion.button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-20 relative"
        >
          <div className="flex items-center justify-center gap-6 perspective-1000">
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl shadow-xl p-6 w-80 transform rotate-[-4deg] hover:rotate-0 transition-transform"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-2 h-2 rounded-full bg-primary mt-2"></div>
                <div className="flex-1">
                  <p className="text-sm text-gray-500 mb-2">Example Prompt:</p>
                  <p className="text-charcoal font-medium leading-relaxed">
                    "Analyze our Q4 sales data and identify the top 3 growth opportunities with specific action steps"
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-xs text-primary">
                <i className="ri-sparkling-line"></i>
                <span>Strategic Business Prompt</span>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10, scale: 1.05 }}
              className="bg-white rounded-2xl shadow-2xl p-8 w-96 z-10"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-2 h-2 rounded-full bg-secondary mt-2"></div>
                <div className="flex-1">
                  <p className="text-sm text-gray-500 mb-2">Advanced Technique:</p>
                  <p className="text-charcoal font-semibold leading-relaxed">
                    "Act as a marketing strategist. Review our campaign brief and provide 5 creative concepts, each with target audience, key message, and channel recommendations"
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-xs text-secondary">
                <i className="ri-lightbulb-flash-line"></i>
                <span>Role-Based Prompting</span>
              </div>
            </motion.div>

            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl shadow-xl p-6 w-80 transform rotate-[4deg] hover:rotate-0 transition-transform"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-2 h-2 rounded-full bg-accent mt-2"></div>
                <div className="flex-1">
                  <p className="text-sm text-gray-500 mb-2">Productivity Boost:</p>
                  <p className="text-charcoal font-medium leading-relaxed">
                    "Create a weekly content calendar for LinkedIn with 5 posts focused on AI adoption in SMBs"
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-xs text-accent">
                <i className="ri-rocket-line"></i>
                <span>Efficiency Prompt</span>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}